<template>
	<div>
		<main style='background: #EEEEEE;height: 900px;'>
			<img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
			<div class="centerBox">
				<div class="liucheng">
					<div>
						<p class="title">机构信息</p>
						<div class="boxItems">
							<p class="contentTitle">{{content.sfjdjgmc}}</p>
							<ul class="jgItem">
								<!-- <li>执业年限：1年执业经验</li> -->
								<li>执业证号：{{content.sfjdjgxkzh}}</li>
								<li>联系地址：{{content.jgzsxxdz}}</li>
								<li>业务专长：{{content.ywfw}}</li>
								<li>联系电话：{{content.jglxdh}}</li>
							</ul>
							<!-- <ul class="jgItem">
								<li>执业证号：{{content.sfjdjgxkzh}}</li>
								<li>联系地址：{{content.jgzsxxdz}}</li>
							</ul> -->
							<p class="contentTitle1">执业信息</p>
								<ul class="jgItem">
									<li>负责人：{{content.jgfzr}}</li>
									<li>地址：{{content.sqrzs}}</li>
									<li>执业许可证号：{{content.sfjdjgxkzh}}</li>
								</ul>
								<ul class="jgItem">
									<li v-if="content.zt==1">执业状态：正常</li>
									<li v-if="content.zt!=1">执业状态：不正常</li>
									<li>批准文号：{{content.sqrzmwjjhm}}</li>
									<li>组织机构代码：{{content.tyshxydm}}</li>
								</ul>
								<ul class="jgItem">
									<li>批准日期：{{content.bzrq}}</li>
									<li>主管机关：{{content.bzjg}}</li>
									<li>传真号码：{{content.jglxdh}}</li>
								</ul>
								<p class="contentTitle1">鉴定范围</p>
								<ul class="jgItem">
									<li>{{content.ywfw}}</li>
								</ul>
								<p class="contentTitle1">机构人员</p>
								<ul class="jgItem">
									<li>{{content.ywfw}}</li>
								</ul>
                                <br/>
                            <el-button   size="medium" style="margin-left: 380px;"  type="primary" plain  @click="goBack">返 回</el-button>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import navheader from '../../components/navheader.vue'
	import footeritem from '../../components/footeritem.vue'
	import axios from 'axios'
	import '../../assets/css/index.less'
	import '../../assets/css/fuWu.less';
	export default {
		name: 'Pdf',
		components: {
			navheader,
			footeritem,
		},
		data() {
			return {
				xxbh:'',
				activeNum: 0,
				content:''
			};
		},
		methods: {
			// 获取详情
			getDetail(xxbh) {
				var params = new URLSearchParams();
				axios.get('/system/JG/' + xxbh).then(res => {
					if (res.data.code == 200) {
						this.content = res.data.data
					}
				}, err => {})
			},
            goBack(){
                this.$router.go(-1);//返回上一层
            }
		},
		created() {

		},
		mounted() {
			let that = this;

			that.getDetail(that.$route.query.xxbh)
		},
	};
</script>

<style lang="less" scoped="scoped">
	/deep/ .distpicker-address-wrapper select{
	margin-top: 10px;
	}
	.address{
		width: 100%;
		height: 400px;
		overflow-y: auto;
		margin-top: 20px;
		.addItem{
			width: 100%;
			border-bottom: 1px dashed #BEBEBE;
			margin-bottom: 10px;
			p{
				width: 100%;
				margin-bottom: 10px;
				&:first-of-type{
					font-size: 16px;
					font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
					font-weight: 600;
					text-align: left;
					color: #000000;
				}
				&:last-of-type{
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei-Regular;
					font-weight: 400;
					text-align: left;
					color: #999999;
				}
			}
		}
	}
	.topImg {
		width: 100%;
		display: block;
	}

	.centerBox {
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}

	.titleTip {
		width: 100%;
		border-left: 4px solid #01458E;
		padding-left: 10px;
	}

	.liucheng {
		position: absolute;
		top: 300px;
		left: 50%;
		margin-left: -500px;

		// background: #F8F8F8;
		// padding: 30px 0;
		&>div {
			width: 1000px;
			height: 700px;
			margin: 0 auto;
			box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
			box-sizing: border-box;
			border-radius: 10px;
			background: #fff;
			overflow: hidden;

			.title {
				width: 100%;
				height: 67px;
				line-height: 67px;
				background: #0068d8;
				padding: 0 30px;
				box-sizing: border-box;
				font-size: 22px;
				font-family: Microsoft YaHei, Microsoft YaHei-Bold;
				font-weight: 700;
				text-align: left;
				color: #ffffff;
				letter-spacing: 1px;
			}

			.boxItems {
				width: 100%;
				padding: 60px;
				box-sizing: border-box;
				overflow: hidden;
				.jgItem{
					width: 100%;
					overflow: hidden;
					li{
						width: 38%;
						float: left;
						font-size: 16px;
						font-family: Microsoft YaHei, Microsoft YaHei-Regular;
						font-weight: 400;
						color: #666666;
						margin-top: 10px;
						&:first-of-type{
							width: 24%;
						}
					}
				}
				.contentTitle{
					width: 100%;
					font-size: 24px;
					font-family: Microsoft YaHei, Microsoft YaHei-Bold;
					font-weight: 700;
					color: #333333;
					margin-bottom: 20px;
				}
				.contentTitle1{
					width: 100%;
					font-size: 18px;
					font-family: Microsoft YaHei, Microsoft YaHei-Bold;
					font-weight: 700;
					text-align: left;
					color: #0068d8;
					margin-top: 50px;
				}
			}

		}

		@media screen and (max-width: 1024px) {
			&>div {
				width: 90%;
			}
		}
	}
</style>
